import React, { useState, useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import "./CompanyList.css";

const CompanyList = () => {
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      if (!searchQuery) {
        setFilteredCompanies([]);
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(
          `https://core-bankers-backend.vercel.app/company-data?search=${searchQuery}`
        );
        const data = await response.json();
        setFilteredCompanies(data.slice(0, 10));
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
      setLoading(false);
    };

    const delayDebounceFn = setTimeout(fetchCompanies, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    setSearchQuery(company.companyname);
    setFilteredCompanies([]);
  };

  return (
    <main className="company-page">
      <section className="company-hero">
        <div className="company-hero-inner">
          <span className="cb-section-label">Tools</span>
          <h1>Company Data</h1>
          <p>Search a company to view CIN and bank eligibility indicators.</p>
        </div>
      </section>

      <div className="company-body">
        <div className="company-search-panel">
          <TextField
            fullWidth
            variant="outlined"
            label="Search company"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="company-search"
            multiline
            maxRows={3}
          />

          {loading && <p className="company-loading">Loading...</p>}

          {filteredCompanies.length > 0 && (
            <div className="company-suggestions">
              {filteredCompanies.map((company) => (
                <MenuItem key={company.id} onClick={() => handleSelectCompany(company)}>
                  {company.companyname}
                </MenuItem>
              ))}
            </div>
          )}
        </div>

        {selectedCompany && (
          <>
            <div className="company-cin-section">
              <p>
                <strong>Company CIN:</strong> {selectedCompany.cin}
              </p>
            </div>

            <div className="company-bank-section">
              <h2>Bank eligibility</h2>
              <div className="bank-table">
                {[
                  ["HDFC", selectedCompany.hdfc],
                  ["Axis", selectedCompany.axis],
                  ["IDFC", selectedCompany.idfc],
                  ["Kotak", selectedCompany.kotak],
                  ["IndusInd", selectedCompany.indusind],
                  ["Yes Bank", selectedCompany.yesbank],
                  ["CSB", selectedCompany.csb],
                  ["Poonawala", selectedCompany.poonawala],
                  ["Tata", selectedCompany.tata],
                  ["L&T", selectedCompany.l_t],
                ].map(([bank, value]) => (
                  <div className="bank-row" key={bank}>
                    <span className="bank-name">{bank}</span>
                    <span className="bank-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </main>
  );
};

export default CompanyList;
